// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { LoadingType } from '../../types/Common';
import { OnlineCourseCard } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface InitState {
  onlineCourseRelatedData: { [key: string]: OnlineCourseCard[] };
  loadingType: LoadingType;
  isLoading: boolean;
  hasMoreRelated: boolean;
  error?: Error;
}

const { getOnlineCourseRelatedActions } = actionCreatorsList;
export const initialState: InitState = {
  onlineCourseRelatedData: {},
  isLoading: true,
  hasMoreRelated: true,
  loadingType: LoadingType.NEW
};

export default function (state = initialState, action: RootAction) {
  switch (action.type) {
    case getType(getOnlineCourseRelatedActions.request): {
      const { loadingType } = action.payload;

      return {
        ...state,
        isLoading: true,
        loadingType,
        error: undefined
      };
    }
    case getType(getOnlineCourseRelatedActions.success): {
      const { id, onlineCourseRelatedData, loadingType } = action.payload;
      const newData =
        loadingType === LoadingType.NEW
          ? onlineCourseRelatedData
          : state.onlineCourseRelatedData[id].concat(onlineCourseRelatedData);
      const hasMoreRelated = onlineCourseRelatedData.length > 0;

      return {
        ...state,
        isLoading: false,
        hasMoreRelated,
        onlineCourseRelatedData: { [id]: newData }
      };
    }
    case getType(getOnlineCourseRelatedActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }

    default: {
      return state;
    }
  }
}
